import { GET_PROJECT_CAMPAIGN, GET_PROJECT_CAMPAIGN_SUCCESS, GET_PROJECT_CAMPAIGN_ERROR, GET_PROJECT_CAMPAIGN_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetProjectCampaign = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECT_CAMPAIGN:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PROJECT_CAMPAIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PROJECT_CAMPAIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PROJECT_CAMPAIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetProjectCampaign;
